/**
 * Null Simulation Provider - no-op implementation
 */
export class NullSimulationProvider {
    async simNum(_title, _text, min, _max) {
        return min;
    }
    async simDigital(_title, _text, _falseStr, _trueStr) {
        return false;
    }
}
//# sourceMappingURL=simulation.js.map